import React from 'react';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styles from '../../../styles/pages/account/account-modal.module.scss';
import { Modal } from '../../../components/modal';
import { CoachMessage } from '../../../components/coach-message';
import { InputButtonWithIcon as ButtonWithIcon } from '../../../components/buttons/button-with-icon';
import { InputGroup } from '../../../components/inputs/input-group';
import { deleteAccount as deleteAccountAction } from '../../../store/reducers/account/actions';

export const AccountModal = React.memo(({ show, onClose, message, loading, children }) => (
  <Modal show={show} onClose={onClose} loading={loading}>
    {message && (
      <CoachMessage>
        <p>{message}</p>
      </CoachMessage>
    )}
    <InputGroup type='coach'>{children}</InputGroup>
  </Modal>
));

export const WrongMagicCodeModal = React.memo(({ show, onClose }) => {
  const {
    ACCOUNT: {
      WRONG_CODE_MODAL: {
        message,
        buttons: { confirm, needHelp }
      }
    }
  } = window.CONFIG;

  return (
    <AccountModal show={show} onClose={onClose} message={message}>
      <ButtonWithIcon onClick={onClose}>{confirm}</ButtonWithIcon>
      {needHelp && (
        <ButtonWithIcon
          data-atid='wrong-magic-code-modal-button'
          type='minor'
          to='mailto:support@firsthomecoach.co.uk'
          isExternal
        >
          {needHelp}
        </ButtonWithIcon>
      )}
    </AccountModal>
  );
});

const DeleteAccountModalComponent = React.memo(({ show, onClose, deleteAccount }) => {
  const {
    ACCOUNT: {
      DELETE_ACCOUNT_MODAL: {
        message,
        buttons: { confirm, decline }
      }
    }
  } = window.CONFIG;

  return (
    <AccountModal show={show} onClose={onClose} message={message}>
      <ButtonWithIcon className={styles.button} type='destructive' onClick={deleteAccount}>
        {confirm}
      </ButtonWithIcon>
      <ButtonWithIcon className={styles.button} type='minor' onClick={onClose}>
        {decline}
      </ButtonWithIcon>
    </AccountModal>
  );
});

export const DeleteAccountModal = compose(
  withRouter,
  connect(null, { deleteAccountAction }),
  withHandlers({
    deleteAccount:
      ({ deleteAccountAction, history }) =>
      () =>
        deleteAccountAction(() => history.push('/account/delete-account/complete'))
  })
)(DeleteAccountModalComponent);
